export default "__VITE_ASSET__4PFO9dEi__"